import { useFormContext } from "@mittwald/flow-components/dist/components/Form";
import Select from "@mittwald/flow-components/dist/components/Select/Select";
import type {
  SelectOptions,
  SelectProps,
} from "@mittwald/flow-components/dist/components/Select/types";
import type { ControlledFormFieldProps } from "@mittwald/flow-components/dist/lib/formControlFactory";
import React, { useEffect, useState } from "react";
import type { RelocationApiData } from "../../../../../../../../../model/relocation/Relocation";
import type { Contract } from "../../../../../../types/LegacySystemAPI";
import { TariffType } from "../../../../TariffStep/utils/TariffUtils";

export type ProjectNumberSelectProps = Partial<
  ControlledFormFieldProps<SelectProps>
> & {
  contracts: Contract[];
};

export const ProjectNumberSelect: React.FC<ProjectNumberSelectProps> = (
  props,
) => {
  const { contracts } = props;
  const form = useFormContext<RelocationApiData>();
  const tariff = form.watch("target.product") as TariffType;
  const [options, setOptions] = useState<SelectOptions>([]);

  useEffect(() => {
    switch (tariff) {
      case TariffType.AGENCY_SERVER:
        setOptions(
          contracts
            .filter((contract) => {
              return contract.account != undefined
                ? contract.account.reseller != null
                  ? contract.account.reseller.articleNumber === 72000
                  : false
                : false;
            })
            .map((contract) => ({
              label: {
                text: `${contract.account?.name} | ${contract.account?.description}`,
              },
              value: contract.account?.name,
            })),
        );
        break;
      case TariffType.SHOP_HOSTING:
        setOptions(
          contracts
            .filter((contract) => {
              return contract.title.includes("SHOP");
            })
            .map((contract) => ({
              label: {
                text: `${contract.account?.name} | ${contract.account?.description}`,
              },
              value: contract.account?.name,
            })),
        );
        break;
      case TariffType.CMS_HOSTING:
        setOptions(
          contracts
            .filter((contract) => {
              return (
                contract.title.includes("CMS") &&
                !contract.title.includes("Agentur-Server")
              );
            })
            .map((contract) => ({
              label: {
                text: `${contract.account?.name} | ${contract.account?.description}`,
              },
              value: contract.account?.name,
            })),
        );
        break;
    }
  }, [contracts]);

  useEffect(() => {
    if (
      options.length === 1 &&
      options[0]?.value &&
      (!form.getValues("target.projectName") ||
        form.getValues("target.projectName") === "")
    ) {
      form.setValue("target.projectName", options[0]?.value);
    }
  }, [options]);

  return <Select name={props.name || ""} options={options} {...props} />;
};
